export default "__VITE_ASSET__66a566e8__"